import { guiguiEnJson } from './guigui'
import localGuiguiJson from './json/guiguiEn.json'
import zhData from './json/zh'

// 获取一个对象的所有value的联合类型
export type GetValueType<T> = T extends Record<string, infer V>
  ? GetValueType<V>
  : T

type ZhDataType = {
  [key: string]: ZhDataType | string
}
// 根据中文内容获取对应的映射
function generateLanguageMap(
  data: ZhDataType,
  languageMap: Map<string, string> = new Map(),
  parentKeys: string[] = []
) {
  Object.keys(data).forEach((key) => {
    parentKeys.push(key)
    const mapKey = data[key]
    if (typeof mapKey === 'string') {
      languageMap.set(mapKey, parentKeys.join('.'))
    } else if (typeof mapKey === 'object') {
      generateLanguageMap(mapKey, languageMap, parentKeys)
    }
    parentKeys.pop()
  })
  return languageMap
}

const languageMap = generateLanguageMap(zhData)

// 翻译文本
export function translateLang(
  key: GetValueType<typeof zhData>,
  payload?: Record<string, any> | Array<any>
) {
  const realKey = languageMap.get(key) || ''
  return window.i18n?.t(realKey, payload) || key
}

// 英文文本
export const translate = (
  key: string,
  languageMap: Map<string, string>,
  payload?: Record<string, any> | Array<any>
) => {
  let realKey = languageMap.get(key)
  if (!realKey) {
    realKey = key
  }
  return window.i18n?.t(realKey, payload)
}

// 获取语言key
export function getLangeKey(key: GetValueType<typeof zhData>) {
  return languageMap.get(key) || ''
}

// 处理定制化标签中双语客户的翻译问题
// 1. 截取字符串中的中文部分
// 2. 通过截取到的中文部分去映射到guiguiEn.json中获取对应的英文翻译
// 3. 将映射到的英文与截取的剩余部分进行拼接
export function translateCustomTag(key: string, type: string) {
  if (!key) return ''
  const guiguiEnJsonMap: { [key: string]: string } = Object.assign(
    {},
    localGuiguiJson,
    guiguiEnJson ?? {}
  )
  // 中文部分
  const chinesePart = key.match(/[\u4e00-\u9fa5]+/)
  // 如果没有中文，直接返回 key
  if (!chinesePart) {
    return key
  }
  // 剩余部分
  const remainingPart = key.replace(chinesePart[0], '')
  // 映射结果
  const englishPart = guiguiEnJsonMap[chinesePart[0]]
  // englishPart去掉空格,并且所有小写
  const trimmedEnglishPart = englishPart
    ? englishPart.replace(/\s+/g, '').toLowerCase()
    : ''
  // 处理A_B_C这种情况
  if (englishPart) {
    if (type === 'roomName' || type === 'loc') {
      return key + '-' + englishPart + remainingPart
    }
    if (type === 'name') {
      const strArr = strToTextSuffixArr(key)
      // 这里做特殊处理兼容A_B_C情况
      // 情况1:柜门01_双开左01_左开
      // 情况2:抽屉01_抽屉左板01  //抽屉01_抽屉右板01
      const transArr = strArr.map((item) => {
        return {
          ...item,
          text: guiguiEnJsonMap[item.text] || item.text,
        }
      })
      // transArr转为字符串
      return key + '-' + textSuffixArrToStr(transArr)
    }
  } else {
    return key
  }
}

function strToTextSuffixArr(str: string) {
  const regex = /([\u4e00-\u9fa5A-Za-z]+)(\d*)/g
  const result: { text: string; suffix: string }[] = []
  let match
  while ((match = regex.exec(str)) !== null) {
    if (match[1]) {
      result.push({
        text: match[1].trim(),
        suffix: match[2] ? match[2].trim() : '',
      })
    }
  }
  return result
}

// 新增：将 [{ text, suffix }] 数组还原为字符串
function textSuffixArrToStr(arr: { text: string; suffix: string }[]): string {
  return arr.map((item) => item.text + (item.suffix || '')).join('_')
}
